import { RouteRecordRaw } from 'vue-router';
import { EmployeeRouteName } from '../constants/routesName';
import { UserRole, ROUTE_CATEGORY } from '../types';

const AroundTheWorldManagement = () =>
  import('@/features/around-the-world/views/AroundTheWorldManagement.vue');
const AroundTheWorldManagementMap = () =>
  import('@/features/around-the-world/views/AroundTheWorldMap.vue');
const DisponibilitiesPage = () => import('@/features/rooms/views/DisponibilitiesPage.vue');
const EmployeeHomePage = () => import('@/features/homepage/views/EmployeeHomePage.vue');
const MenuManagement = () => import('@/features/menu-management/views/MenuManagementPage.vue');
const NewsPage = () => import('@/features/news/views/NewsPage.vue');
const NewsDetailPage = () => import('@/features/news/views/NewsDetailPage.vue');
const PlanningPage = () => import('@/features/rooms/views/PlanningPage.vue');

/**
 * Routes dédiées aux collaborateurs
 */
export const employeeRoutes: RouteRecordRaw[] = [
  {
    path: '/employee-home',
    name: EmployeeRouteName.EmployeeHome,
    component: EmployeeHomePage,
    meta: {
      requiresRole: UserRole.COLLABORATEUR,
      title: 'routes.employeeHome',
      icon: 'home-outline',
      category: ROUTE_CATEGORY.COLLABORATEUR,
    },
  },
  // Rooms routes
  {
    path: '/rooms/planning',
    name: EmployeeRouteName.RoomsPlanning,
    component: PlanningPage,
    meta: {
      requiresRole: UserRole.COLLABORATEUR,
      title: 'routes.roomsPlanning',
      icon: 'business-outline',
      category: ROUTE_CATEGORY.COLLABORATEUR,
    },
  },
  {
    path: '/rooms/disponibilities',
    name: EmployeeRouteName.RoomsDisponibilities,
    component: DisponibilitiesPage,
    meta: {
      requiresRole: UserRole.COLLABORATEUR,
      title: 'routes.roomsAvailability',
      icon: 'calendar-outline',
      category: ROUTE_CATEGORY.COLLABORATEUR,
    },
  },
  // News routes
  {
    path: '/news',
    name: EmployeeRouteName.EmployeeNews,
    component: NewsPage,
    meta: {
      requiresRole: UserRole.COLLABORATEUR,
      title: 'routes.news',
      icon: 'newspaper-outline',
      category: ROUTE_CATEGORY.COLLABORATEUR,
    },
  },
  {
    path: '/news/:id',
    name: EmployeeRouteName.EmployeeNewsDetail,
    component: NewsDetailPage,
    meta: {
      requiresRole: UserRole.COLLABORATEUR,
      title: 'routes.newsDetail',
      hideInMenu: true,
      category: ROUTE_CATEGORY.COLLABORATEUR,
    },
  },
  // Around The World routes
  {
    path: '/around-the-world-management',
    name: EmployeeRouteName.AroundTheWorldManagement,
    component: AroundTheWorldManagement,
    meta: {
      requiresRole: UserRole.COLLABORATEUR,
      title: 'routes.aroundTheWorld',
      icon: 'earth-outline',
      category: ROUTE_CATEGORY.COLLABORATEUR,
    },
  },
  {
    path: '/around-the-world-management/map',
    name: EmployeeRouteName.AroundTheWorldManagementMap,
    component: AroundTheWorldManagementMap,
    meta: {
      requiresRole: UserRole.COLLABORATEUR,
      title: 'routes.aroundTheWorld',
      icon: 'earth-outline',
      hideInMenu: true,
      category: ROUTE_CATEGORY.COLLABORATEUR,
    },
  },
  {
    path: '/menu-management',
    name: EmployeeRouteName.MenuManagement,
    component: MenuManagement,
    meta: {
      requiresRole: UserRole.ADMINISTRATOR,
      title: 'routes.menuManagement',
      icon: 'link-outline',
      category: ROUTE_CATEGORY.COLLABORATEUR,
    },
  },
];
